import React from "react";

//ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Col, Form, Tooltip } from "antd";

//PROJECT IMPORTS
import { BOM } from "../../../../services/definedMethod";

const { Text } = Typography;

export const SettingsForm = (props) => {
  const { fixedDepositDetails } = props;

  return (
    <Card
      style={{
        marginBottom: "2%",
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        padding: 10,
      }}
    >
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Lock-in Period</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={fixedDepositDetails?.lockinPeriodFrequency}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Lock-in Period Frequency Type</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={fixedDepositDetails?.lockinPeriodFrequencyType?.value}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Minimum Deposit Term</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={fixedDepositDetails?.minDepositTerm}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Minimum Deposit Term Type</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={fixedDepositDetails?.minDepositTermType?.value}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>And Thereafter, In Multiples Of </Text>}
          >
            <Input
              className="of-bold-disable-input"
              value={fixedDepositDetails?.currency?.inMultiplesOf}
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip title="And Thereafter, In Multiples Of Types">
                <Text strong>
                  {BOM.SubstringFormat(
                    "And Thereafter, In Multiples Of Types",
                    25
                  )}
                </Text>
              </Tooltip>
            }
          >
            <Input
              className="of-bold-disable-input"
              value={fixedDepositDetails?.inMultiplesOfDepositTermType?.value}
              disabled
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Maximum Deposit Term </Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={fixedDepositDetails?.maxDepositTerm}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Maximum Deposit Term Type</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={fixedDepositDetails?.maxDepositTermType?.value}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Text strong>Apply Penal Interest for Pre-mature Closure?</Text>
            }
          >
            <Input
              className="of-bold-disable-input"
              value={
                fixedDepositDetails?.preClosurePenalApplicable ? "Yes" : "No"
              }
              disabled
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Apply Penal Interest (less) </Text>}>
            <Input
              className="of-bold-disable-input"
              value={fixedDepositDetails?.preClosurePenalInterest}
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>On </Text>}>
            <Input
              className="of-bold-disable-input"
              value={fixedDepositDetails?.preClosurePenalInterestOnType?.value}
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Is Withhold Tax Applicable</Text>}>
            <Input
              className="of-bold-disable-input"
              value={fixedDepositDetails?.withHoldTax ? "Yes" : "No"}
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>Tax Group</Text>}>
            <Input
              className="of-bold-disable-input"
              value={fixedDepositDetails?.taxGroup?.name}
              disabled
            />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};
